import { useInstance } from '@meraki-internal/react-dependency-injection';
import { ILightCareMap } from '../caremap/ICareMap';
import { OrganizationsState } from './OrganizationsState';
import { useSubscription } from '@meraki-internal/state';
import { OrganizationClientCareMapRow } from './OrganizationClientCareMapRow';

export type IOrganizationCareMapMenuItemProps = {
    careMap: ILightCareMap;
    onClick?: (map: ILightCareMap) => void;
};

export const OrganizationCareMapMenuItem: React.FC<IOrganizationCareMapMenuItemProps> = (props) => {
    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    const disabled = !orgState.canViewClientCareMap(props.careMap);

    const onClickAdapter = (careMap: ILightCareMap) => {
        if (props.onClick){
            props.onClick(careMap);
        }
    };

    // Why the row is inert is explained beside the client, next to the menu.
    return <OrganizationClientCareMapRow careMap={props.careMap} disabled={disabled} onClick={onClickAdapter} />;
};
